import { atom } from "recoil";

// form id atom
export const formId = atom({
  key: "formId",
  default: localStorage.getItem("formId") || "",
});

// atom for loading for unit admin's edit page;
export const editLoading = atom({
  key: "editLoading",
  default: false,
})


export const formProgress = atom({
  key: "formProgress",
  default: 0,
});

export const unitIndex = atom({
  key: "unitIndex",
  default: "",
});
// export const AuditformProgress = atom({
//   key: "AuditformProgress",
//   default: 1,
// });

export const unitDetailDisableButton = atom({
  key: "unitDetailDisableButton",
  default: true, // true means, needs to disable the  buttons
});

export const offsiteDisableButton = atom({
  key: "offsiteDisableButton",
  default: true, // true means, needs to disable the  buttons
});

export const unitDetailsSubmitAtom = atom({
  key: "unitDetailsSubmitAtom",
  default: false,
});

export const auditSaveData = atom({
  key: "auditSaveData",
  default: {
    unitDetails: [
      {
        name: "unitIndex",
        // label: "Unit Index (3 Digit) and Unit Name",
        value: "",
      },
      {
        name: "unitType",
        // label: "Unit Type",
        value: "",
      },
      {
        name: "manufacturingCode",
        // label: "Manufacturing Code (3 Letter) (if applicable)",
        value: "",
      },
      {
        name: "qualityManager",
        // label: "Quality Manager or Lead Auditee ",
        value: localStorage.getItem("userName"),
      },
      {
        name: "qualityManagerEmail",
        // label: "Quality Manager or Lead Auditee Email",
        value: localStorage.getItem("myemail"),
      },
      {
        name: "certifications",
        // label: "Current Third Party Certifications Held",
        value: "",
      },
      {
        name: "parentUnit",
        // label: "Parent Unit Name",
        value: "",
      },
      {
        name: "unitCountry",
        // label: "Unit Country",
        value: "",
      },
      {
        name: "unitRegion",
        // label: "Unit Region",
        value: "",
      },
      {
        name: "cbName",
        // label: "CB Name",
        value: "",
      },
      {
        name: "enterprise",
        // label: "Enterprise",
        value: "",
      },
      {
        name: "responsibleSegment",
        // label: "Responsible Segment",
        value: "",
      },
      {
        name: "responsibleDivision",
        // label: "Responsible Division",
        value: "",
      },
      {
        name: "responsibleDivisionId",
        // label: "Responsible Division ID",
        value: "",
      },
      {
        name: "businessUnitId",
        // label: "Business Unit Id",
        value: "",
      },
      {
        name: "businessUnit",
        // label: "Business Unit",
        value: "",
      },
      {
        name: "subBusinessUnit",
        // label: "Sub Business Unit",
        value: "",
      },
    ],
    offSiteFields: [
      {
        name: "offSiteActivities",
        // label: "Off-Site Activities (if applicable)",
        value: "",
      },
      {
        name: "offsiteActivity",
        // label: "Type of Off-Site Activity",
        value: "",
      },
      {
        name: "locationAudited",
        // label: "Is Location Currently Audited?",
        value: "",
      },
      {
        name: "siteName",
        // label: "Site Name",
        value: "",
      },
      {
        name: "AuditingLocation",
        // label: "If Yes - Who is Auditing Location",
        value: "",
      },
    ],
  },
});

export const unitAdminEditData = atom({
  key: "unitAdminEditData",
  default: {
    unitDetails: [],
    offSiteFields: [],
  },
});

export const MarsformProgress = atom({
  key: "MarsformProgress",
  default: 3,
});

export const savedLoading = atom({
  key: "savedLoading",
  default: false,
});

export const submitLoading = atom({
  key: "submitLoading",
  default: false,
});

export const editAuditNumber = atom({
  key: "editAuditNumber",
  default: localStorage.getItem("auditNumber") || "",
});
